export default {
  apiKey: 'AIzaSyCbOS5r4LCD-GvRMy91PF4eShky-G_aJto',
  authDomain: 'crv-lagoa.firebaseapp.com',
  projectId: 'crv-lagoa',
  storageBucket: 'crv-lagoa.appspot.com',
  messagingSenderId: '454572947289',
  appId: '1:454572947289:web:b4fd277becc7d10185be48',
  measurementId: 'G-80H9Y6G3ZF'
};